import { takeEvery, call, put } from 'redux-saga/effects';
import { gcApi } from 'config/axios';
import {
    FETCH_EMAIL_NOTIFICATIONS,
    FETCH_EMAIL_NOTIFICATIONS_FETCHING,
    FETCH_EMAIL_NOTIFICATIONS_SUCCESS,
    FETCH_EMAIL_NOTIFICATIONS_FAIL,
    UPDATE_EMAIL_NOTIFICATIONS,
    UPDATE_EMAIL_NOTIFICATIONS_UPDATING,
    UPDATE_EMAIL_NOTIFICATIONS_SUCCESS,
    UPDATE_EMAIL_NOTIFICATIONS_FAIL
} from 'actions/ActionTypes';

// Workers
export function* fetchEmailNotificationsSaga(action = {}) {
    try {
        yield put({
            type: FETCH_EMAIL_NOTIFICATIONS_FETCHING
        });

        const response = yield call(gcApi.get, `/notification-service/preference/userPreference`);

        yield put({
            type: FETCH_EMAIL_NOTIFICATIONS_SUCCESS,
            emailNotifications: response.data
        });
    } catch (e) {
        yield put({
            type: FETCH_EMAIL_NOTIFICATIONS_FAIL
        });
    }
}

export function* updateEmailNotificationsSaga(action = {}) {
    const { updatedEmailNotifications } = action;

    try {
        yield put({
            type: UPDATE_EMAIL_NOTIFICATIONS_UPDATING
        });

        const response = yield call(
            gcApi.put,
            `/notification-service/preference/userPreference`,
            updatedEmailNotifications
        );

        yield put({
            type: UPDATE_EMAIL_NOTIFICATIONS_SUCCESS,
            updatedEmailNotifications: updatedEmailNotifications
        });
    } catch (e) {
        yield put({
            type: UPDATE_EMAIL_NOTIFICATIONS_FAIL
        });
    }
}

// Watchers
export const emailNotificationSagas = [
    takeEvery(FETCH_EMAIL_NOTIFICATIONS, fetchEmailNotificationsSaga),
    takeEvery(UPDATE_EMAIL_NOTIFICATIONS, updateEmailNotificationsSaga)
];
